import React from 'react';
import { useSelector } from 'react-redux';
import { RootReducer } from '@store/index';
import ExpenseForm from '@components/Expenses/ExpenseForm';

/**
 * Registro de gastos del POS (plan de Gastos §5.1). Separado de la calculadora,
 * que se queda con los ingresos y el cobro de pedidos. El formulario es el mismo
 * que usan el Informe y la edición (`ExpenseForm`); aquí siempre es la sucursal en
 * operación.
 */
const ExpenseRegister: React.FunctionComponent = () => {
    const { branchOfficeSelected } = useSelector((state: RootReducer) => state.auth);
    return <ExpenseForm branchOfficeId={branchOfficeSelected?.id} title="Registro de gastos" />;
};

export default ExpenseRegister;
